// eslint-disable-next-line
export const updateCalendarConstants = {
  UPDATE_CALENDAR: 'UPDATE_CALENDAR',
  UPDATE_CALENDAR_DONE: 'UPDATE_CALENDAR_DONE',
};
